export default "__VITE_ASSET__CBzjjFhv__"